import GlobalLabelFilters from "../../../../../global/GlobalLabelFilters";

const TIMING_FILTER_ITEMS = [
  { key: "all", label: "All", variant: "all" },
  { key: "upcoming", label: "U Upcoming", variant: "upcoming" },
  { key: "closing_2d", label: "U Closing in 2 days", variant: "2d" },
  { key: "closing_1d", label: "U Closing in 1 day", variant: "1d" },
  { key: "ongoing", label: "O Ongoing", variant: "ongoing" },
  { key: "completed", label: "C Completed", variant: "completed" },
];

export default function ParticipantsListLabelFiltersSection({
  tournamentTimingFilter,
  onSetTimingAll,
  onToggleTiming,
}) {
  return (
    <GlobalLabelFilters
      ariaLabel="Filter participants by tournament timing"
      items={TIMING_FILTER_ITEMS}
      activeKey={tournamentTimingFilter}
      onAll={onSetTimingAll}
      onToggle={onToggleTiming}
    />
  );
}
